import { useSEO, SEOMetadata } from '../../hooks/useSEO';

interface SEOHeadProps {
  metadata: SEOMetadata;
}

/**
 * SEOHead component that manages all SEO-related meta tags
 * This component uses the useSEO hook to update document head
 */
export const SEOHead = ({ metadata }: SEOHeadProps) => {
  useSEO(metadata);
  return null; // This component doesn't render anything
};

